export default function (name) {
  const lName = name.toLowerCase().trim();
  const cleanName = lName.replace(' coop', '').replace(' ap', '');
  return cleanName;
}
